"use strict";

class AbortControllerImpl {
  constructor(args, privateData) {
    this.signal = privateData.AbortSignal.createImpl([]);
  }

  abort() {
    this.signal._signalAbort();
  }
}

module.exports = {
  implementation: AbortControllerImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/aborting/AbortController-impl.js
// module id = lA1k
// module chunks = 0